import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import type { TodoState } from '@erikdakoda/database/enums';
import type { TodoItemForSidebar } from '@erikdakoda/todo/types';
import TodoStateControl from './TodoStateControl';

type TodoListItemProps = {
  item: TodoItemForSidebar;
  selected: boolean;
  onSelect: (id: string) => void;
  onStateChange: (id: string, state: TodoState) => void;
  onTrashed?: (id: string) => void;
};

/**
 * Sidebar row for a single todo item.
 */
export default function TodoListItem({
  item,
  selected,
  onSelect,
  onStateChange,
  onTrashed,
}: TodoListItemProps) {
  'use memo';

  return (
    <ListItemButton
      className="todo-list-item"
      selected={selected}
      onClick={() => onSelect(item.id)}
      sx={{ py: 0.5, gap: 2, alignItems: 'flex-start' }}
    >
      <TodoStateControl
        todoId={item.id}
        state={item.state}
        onChange={(state) => onStateChange(item.id, state)}
        onTrashed={() => onTrashed?.(item.id)}
        size="small"
      />
      <ListItemText primary={item.name} sx={{ minWidth: 0, margin: 0 }} />
    </ListItemButton>
  );
}
